import generateActions from 'utils/actions';
import uuidv4 from 'utils/uuid';

export const SET_FIELD = 'ads/SET_FIELD';
export const DELETE_FILE = generateActions('ads/DELETE_FILE');
export const GET_CAMPAIGN = generateActions('ads/GET_CAMPAIGN');
export const GET_CAMPAIGNS = generateActions('ads/GET_CAMPAIGNS');
export const POST_CAMPAIGNS = generateActions('ads/POST_CAMPAIGNS');
export const POST_FILE = generateActions('ads/POST_FILE');
export const PUT_CAMPAIGNS = generateActions('ads/PUT_CAMPAIGNS');

export function loadCampaign(id) {
  return {
    types: GET_CAMPAIGN,
    promise: {
      url: `/ads/campaigns/${id}`,
    },
    data: { id: parseInt(id, 10) },
  };
}

export function loadCampaigns() {
  return {
    types: GET_CAMPAIGNS,
    promise: {
      url: '/ads/campaigns',
    },
  };
}

export function postCampaign(campaign) {
  return {
    types: POST_CAMPAIGNS,
    promise: {
      url: '/ads/campaigns',
      method: 'POST',
      data: campaign,
    },
  };
}

export function putCampaign(campaign) {
  return {
    types: PUT_CAMPAIGNS,
    promise: {
      url: `/ads/campaigns/${campaign.id}`,
      method: 'PUT',
      data: campaign,
    },
  };
}

export function postFile(campaign, name, file, onProgress) {
  return {
    types: POST_FILE,
    data: { file, type: name, id: uuidv4() },
    promise: {
      url: `/ads/campaigns/${campaign.id}/upload`,
      method: 'POST',
      onProgress: file instanceof File ? onProgress : undefined,
      form: {
        [name]: file
      },
    },
  };
}

export function deleteFile(campaign, file) {
  return {
    types: DELETE_FILE,
    data: { campaign, file },
    promise: {
      url: `/ads/campaigns/${campaign.id}/file/${file.id}`,
      method: 'DELETE',
    },
  };
}

export function setField(name, value) {
  return {
    type: SET_FIELD,
    payload: { name, value },
  };
}